'use strict';

var globalHeaderComponent = {
  templateUrl: 'templates/partials/global/header.tpl.html',
  bindings: {
    onLogOut: '&',
  },
  controller: /*@ngInject*/ function (
    $scope,
    $state,
    Session,
    KeymageService,
    ReactNavigationService,
    FeatureFlagService
  ) {
    var _self = this;

    _self.setKeyBindings = function () {
      KeymageService.set($scope, [
        {
          shortcut: 'ctrl-s',
          fn: function () {
            if (FeatureFlagService.isEnabled('global-search-v2-nav')) {
              ReactNavigationService.goToSearch();
            } else {
              $state.go('search');
            }
          },
        },
      ]);
    };

    _self.setUserData = function () {
      _self.user = {
        name: Session.get('name'),
      };
    };

    _self.$onInit = function () {
      _self.reactRoutingEnabled = FeatureFlagService.isEnabled(
        'global-search-v2-nav'
      );

      _self.setUserData();
      _self.setKeyBindings();
    };

    _self.showLogoutModal = function () {
      _self.onLogOut();
    };
  },
};

module.exports = globalHeaderComponent;
